import { getAnalytics, logEvent } from "firebase/analytics";
import { useCallback, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { ROUTE_FREE_TRIAL, ROUTE_SIGN_IN, ROUTE_SUBSCRIBE, ROUTE_WELCOME_ONBOARD } from "../lib/constants";

const pageTitles: {[key: string]: string} = {
  [ROUTE_SIGN_IN]: "Sign In",
  [ROUTE_FREE_TRIAL]: "Free Trial",
  [ROUTE_SUBSCRIBE]: "Subscribe",
  [ROUTE_WELCOME_ONBOARD]: "Welcome Onboard",
}

const useAnalytics = () => {
  const { pathname, search } = useLocation();

  const logAnalytics = useCallback(() => {
    const analytics = getAnalytics();
    logEvent(analytics, "page_view", {
      path: pathname,
      search: search,
      page_title: pageTitles[pathname] || 'unmapped',
    });
  }, [pathname, search]);

  useEffect(() => {
    logAnalytics();
  }, [logAnalytics, pathname]);
};

export default useAnalytics;
